// import { useEffect } from 'react';
// const AdBanner = (props) => {
//   useEffect(() => {
//     try {
//       (window.adsbygoogle = window.adsbygoogle || []).push({});
//     } catch (err) {
//       console.log(err);
//     }
//   }, []);

//   return (
//     <ins
//       className="adsbygoogle adbanner-customize"
//       style={{
//         display: `block`,
//         overflow: `hidden`,
//       }}
//       data-ad-client={process.env.NEXT_PUBLIC_GOOGLE_ADS_CLIENT_ID}
//       {...props}
//     />
//   );
// };
// export default AdBanner;
// xport default AdBanner;

'use client';

import { useEffect, CSSProperties, FC } from 'react';

// Define the type for props
interface AdBannerProps {
  className?: string;
  style?: CSSProperties;
  'data-ad-client'?: string;
}

// Extend the Window interface to include adsbygoogle
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const AdBanner: FC<AdBannerProps> = (props) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: `block`, textAlign: `center` }}
      data-ad-layout="in-article"
      data-ad-format="fluid"
      data-ad-client="ca-pub-3436497941634374"
      data-ad-slot="5372747887"
    />
  );
};

export default AdBanner;
